/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{{SITECORE_API_KEY}}",
  "sitecoreApiHost": "{{SITECORE_API_HOST}}",
  "jssAppName": "{{SITECORE_JSS_APP_NAME}}",
  "defaultLanguage": "{{SITECORE_DEFAULT_LANG}}",
  "graphQLEndpointPath": "/api/{{SITECORE_JSS_APP_NAME}}",
  "graphQLEndpoint": "{{SITECORE_API_HOST}}/api/{{SITECORE_JSS_APP_NAME}}?sc_apikey={{SITECORE_API_KEY}}"
};